export default __webpack_public_path__ + "static/media/banner-12.cda15124.jpg";